import { FaLaptopCode, FaUsersCog, FaShoppingCart } from "react-icons/fa";

const webDevData = {
  mainTitle: "Professionelle Web-Lösungen für Wachstum",
  mainDescription:
    "Wir entwickeln leistungsstarke Webseiten, CRM-Systeme und maßgeschneiderte eCommerce-Lösungen. Ob Sie eine elegante Business-Website, ein leistungsfähiges Kundenportal oder einen robusten Onlineshop benötigen – wir haben die perfekte Lösung für Sie.",

  services: [
    {
      id: 1,
      icon: <FaLaptopCode />,
      title: "Statische & Mehrseitige Webseiten",
      description:
        "Wunderschön gestaltete Webseiten und One-Pager, die schnell, SEO-optimiert und mobilfreundlich sind. Entwickelt für Leistung und Skalierbarkeit.",
      features: [
        "SEO-Optimierung",
        "WordPress-Integration",
        "Mobile-First-Design",
        "Benutzerdefinierte Animationen",
      ],
    },
    {
      id: 2,
      icon: <FaUsersCog />,
      title: "CRM- und Portal-Lösungen",
      description:
        "Steigern Sie die Kundenbindung mit leistungsstarken CRM- und Portal-Lösungen. Sicher, cloudbasiert und auf Ihre Geschäftsanforderungen zugeschnitten.",
      features: [
        "Individuelle CRM-Entwicklung",
        "Benutzerverwaltung",
        "Sichere Authentifizierung",
        "Cloud-Hosting",
      ],
    },
    {
      id: 3,
      icon: <FaShoppingCart />,
      title: "Individuelle Online-Shops",
      description:
        "Erhalten Sie einen vollständig an Ihre Bedürfnisse angepassten Onlineshop mit nahtloser Benutzererfahrung, sicheren Zahlungen und einfacher Produktverwaltung.",
      features: [
        "E-Commerce-Integration",
        "Einrichtung von Zahlungsgateways",
        "Produktverwaltung",
        "Bestellverfolgung",
      ],
    },
  ],
};

export default webDevData;
